import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ModalControlComponent } from '../modal-control/modal-control.component';

@Injectable({
  providedIn: 'root'
})
export class ModalControlService {

  modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }

  launchModal(id: string, title: string, type: string, modalClass: string = "", expandSummary: boolean = false){
    const initialState = {
      componentId: id,
      title: title,
      type: type,
      class: modalClass,
      expandSummary: expandSummary
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalRef = this.modalService.show(ModalControlComponent, {class: 'modal-dialog-centered modal-control ' + modalClass, ignoreBackdropClick:true, keyboard: false, initialState});

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })
  }
}
